import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useUpdateConfigDataMutation } from "../../../../../../services/configuration/ConfigDataServices";
import Toster from "../../../Toster";
import AddBlogSubCategory from "../add/AddBlogSubCategory";
import { CircularProgress } from "@mui/material";
import AuthWrapper from "../../../../../../utils/AuthWrapper";

const BlogSubCategoryListing = ({ configDataId, columns, rows, loading }) => {
  const [isOpenAddDialog, setIsOpenAddDialog] = useState(false);
  const [add, addInfo] = useUpdateConfigDataMutation();

  return (
    <div>
      <AuthWrapper type="ACTION" name="CONFIGURATION_BLOG_SUB_CATEGORY_ADD">
        <Grid container justifyContent="flex-start" className="my-3 px-3">
          <Button variant="contained" onClick={() => setIsOpenAddDialog(true)}>
            Add new sub category
          </Button>
        </Grid>
      </AuthWrapper>
      <AuthWrapper type="ACTION" name="CONFIGURATION_BLOG_SUB_CATEGORY_LIST">

      {loading ? (
        <div className="d-flex justify-content-center">
          <CircularProgress />{" "}
        </div>
      ) : (
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    z
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      </AuthWrapper>

      {isOpenAddDialog && (
        <AddBlogSubCategory
          onClose={() => setIsOpenAddDialog(false)}
          configDataId={configDataId}
          add={add}
        />
      )}
      {addInfo?.data && <Toster info={addInfo} />}
    </div>
  );
};

export default BlogSubCategoryListing;
